import { lazy } from 'react';

/**
 * The CAD viewer's lazy boundary — what keeps partviewer's renderer and three.js
 * out of the app's initial bundle.
 *
 * Targets the component module directly rather than the package barrel. Importing
 * the barrel here looked equivalent but was not: the barrel is *also* imported
 * eagerly by ~39 files for `constants`/`utils`, so three ended up in an initial
 * chunk anyway and this boundary bought nothing. `@frontend/partviewer`'s barrel is
 * now three-free by contract, and the engine is reachable only from here.
 */
export default lazy(() =>
  import(
    /* webpackChunkName: 'part_viewer' */ '@frontend/partviewer/src/viewer-component'
  ),
);
